import { SvgIcon } from '@/components/svgIcon';
import Email from '@/public/icons/email.svg';
import Telefon from '@/public/icons/telefon.svg';

export type IconFieldData = {
  iconName: IconName;
};

export enum IconName {
  TELEFON = 'telefon',
  EMAIL = 'email',
}

const IconField: React.FC<IconFieldData & React.AriaAttributes> = ({ iconName, ...ariaAttributes }) => {
  // TODO: Automization?
  switch (iconName) {
    case IconName.TELEFON:
      return <SvgIcon component={Telefon} {...ariaAttributes} />;
    case IconName.EMAIL:
      return <SvgIcon component={Email} {...ariaAttributes} />;
    default:
      return null;
  }
};

export default IconField;
